import { useMemo } from "react";
import { CourseCardProps } from "./props.type";
import { CourseStatus } from "@/services/courses/types/course.types";
import Theme from "@/utils/theme";
import { useRegistrationCompletion } from "@/hooks/useRegistrationCompletion";

export const useCourseCard = ({ course }: Partial<CourseCardProps>) => {
  const { isRegistrationComplete } = useRegistrationCompletion();

  const isPending = useMemo(() => {
    if (isRegistrationComplete) return false;
    return course?.status === CourseStatus.PENDING;
  }, [course?.status, isRegistrationComplete]);

  const status = useMemo(() => {
    if (isRegistrationComplete) {
      return {
        text: "Concluído",
        color: Theme.colors.feedback.positive,
      };
    }

    if (!course?.courseUrl) {
      return {
        text: "Aguarde liberação",
        color: Theme.colors.neutral.mid_dark,
      };
    }

    if (isPending) {
      return {
        text: "Pendente",
        color: Theme.colors.feedback.warning,
      };
    }

    if (course?.status === CourseStatus.IN_PROGRESS) {
      return {
        text: "Em Progresso",
        color: Theme.colors.feedback.info,
      };
    }

    return {
      text: "Finalizado",
      color: Theme.colors.feedback.info,
    };
  }, [course, isPending, isRegistrationComplete]);

  return { isPending, status };
};
